// extracted by mini-css-extract-plugin
export default {"content":"unhandled-error-message-content-JLOz9o","deleteConfiguration":"unhandled-error-message-deleteConfiguration-kJYudf"};